<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Edit Outbound Variant Order - {{ order_no }}
        <span v-if="order_key">({{ order_key }})</span>
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>

    <template>
      <v-card>
        <v-card-title>
          <span class="body-1 font-weight-bold"
            >Edit <i class="caption red--text ml-4"> * required field</i></span
          >
        </v-card-title>

        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-row class="text-center py-0">
              <v-col
                cols="12"
                sm="4"
                class="pb-0"
                v-if="
                  userCategory.user_category === 3 ||
                  userCategory.user_category == 6
                "
              >
                <v-text-field
                  v-model="clientName"
                  label="Client"
                  class="required pb-0"
                  @focus="fetchClientList"
                  outlined
                  disabled
                  :loading="clientLoader"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4" class="pb-0">
                <v-text-field
                  v-model="infor_storer_id_text"
                  label="Storer Name"
                  :rules="[(v) => !!v || 'Storer Name is required.']"
                  class="required"
                  outlined
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" class="pb-0">
                <v-text-field
                  v-model="parent_outbound_id__receipt_key"
                  label="Parent Order key"
                  class="pb-0"
                  outlined
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>

            <v-divider class="mb-4" v-if="list && list.length"></v-divider
            ><br />
            <v-row>
              <v-data-table
                :headers="headers"
                :items="list"
                class="elevation-1 custom-icon-size mr-2 ml-3"
                disable-pagination
                hide-default-footer
                v-if="list && list.length"
                width="100%"
              >
                <template v-slot:[`item.mfg_date`]="{ item }">
                  <span v-if="item.mfg_date">{{
                    item.mfg_date | localMomentNew | moment("DD MMM, YYYY")
                  }}</span>
                </template>

                <template v-slot:[`item.expiry_date`]="{ item }">
                  <span v-if="item.expiry_date">{{
                    item.expiry_date | localMomentNew | moment("DD MMM, YYYY")
                  }}</span>
                </template>
                <template v-slot:[`item.created_at`]="{ item }">
                  <span v-if="item.created_at">{{
                    item.created_at
                      | uaeDateTime
                      | moment("DD MMM, YYYY hh:mm A")
                  }}</span>
                  <br /><span v-if="item.created_by"
                    >({{ item.created_by }})</span
                  >
                </template>
                <template v-slot:[`item.updated_at`]="{ item }">
                  <span v-if="item.updated_at">{{
                    item.updated_at
                      | uaeDateTime
                      | moment("DD MMM, YYYY hh:mm A")
                  }}</span>
                  <br /><span v-if="item.updated_by"
                    >({{ item.updated_by }})</span
                  >
                </template>
              </v-data-table>
              <br />
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="pb-0">
                <v-file-input
                  v-model="file"
                  label="Upload File"
                  clearable
                  prepend-icon=""
                  prepend-inner-icon="mdi-paperclip"
                  accept=".xlsx"
                  class="required pb-0"
                  :rules="[(v) => !!v || 'File is required.']"
                  outlined
                  @click="file = null"
                >
                </v-file-input>
              </v-col>
            </v-row>
            <div class="text-left">
              <v-btn
                color="green"
                dark
                class="mr-2 mt-2"
                @click="listPage"
                v-if="checkPermission('app_ecom_vendors:excel_details')"
              >
                Uploaded List
              </v-btn>

              <v-btn
                class="primary mt-2"
                @click="saveForm()"
                :loading="uploadOrder"
                v-if="!errorFound"
                >Update</v-btn
              >
              <v-btn
                class="readonly-button mt-2"
                disabled
                @click="saveForm()"
                :loading="uploadOrder"
                v-else
                >Update</v-btn
              >
              <v-btn
                color="info"
                class="ml-3 mt-2"
                :loading="downloader"
                v-if="client"
                @click="downloadTemplate()"
                >Download template</v-btn
              >
              <v-btn color="white" class="mt-2 ml-4" @click="reset()"
                >Cancel</v-btn
              >
            </div>
          </v-form>
        </v-card-text>
      </v-card>
    </template>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {},
  computed: {
    ...mapGetters(["userCategory"]),
    getStartDate() {
      var startDate = new Date();
      startDate.setDate(startDate.getDate() + 1);
      startDate.setHours(0, 0, 0, 0);
      return startDate.toISOString().split("T")[0];
    },

    _headers() {
      return this.headers.filter((i) => {
        return this.userCategory.user_category !== 3
          ? i.value !== "client"
          : true;
      });
    },
  },
  data: () => ({
    timelinePopup: false,
    parent_receipt_nos: [],
    parent_receipt_no: null,
    receipt_key: null,
    receipt_no: null,
    receipt: null,
    receipts: [],
    received_by: null,
    date: null,
    dateMenu: false,
    adddialog: false,
    openMessage: false,
    detailsData: [],
    tableDetailsItems: [],

    totalDetails: 0,
    optionsDetails: {
      page: 1,
      itemsPerPage: 25,
      sortDesc: [false],
    },
    dialogItem: false,
    listloader: false,
    iconLoader: false,
    isloading: false,
    carriers: [],
    isTableloading: false,
    itemCalled: false,
    sku: null,
    client: null,
    loading: false,
    list: [],
    listLoader: false,
    filtersArr: {},
    clients: [],
    total: 0,
    options: {},
    categories: [],
    categoryLoader: false,
    category: "",
    downloader: false,
    dialog: false,
    file: null,
    selectedClient: "",
    fileLoader: false,
    statusList: [],
    vendorInvoiceNumber: "",
    selectedStatus: "",

    tableData: [],
    totals: 0,
    syncButton: false,
    expand: [],
    purchase_order_code: "",
    vendor_code: "",
    expanded: [],
    tableDataItems: [],
    selectedGrn: "",
    expandedRow: null,
    itemFound: {},
    downloaderRow: false,
    selectedItem: {},
    order_no: null,
    headers: [
      {
        text: "SKU",
        value: "sku",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: 150,
      },

      {
        text: "External Line No",
        value: "externlineno",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: "100px",
      },

      {
        text: "UOM",
        value: "uom",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Allocation Strategy",
        value: "allocation_strategy",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "Unit Price",
        value: "unit_price",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },

      {
        text: "Open Qty",
        value: "open_qty",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
      },
      {
        text: "Pack",
        value: "pack",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: "100px",
      },
      {
        text: "Line",
        value: "line",
        class: "body-1 font-weight-bold",
        align: "left",
        sortable: false,
        width: "100px",
      },

      {
        text: "Lottable07",
        value: "lottable07",
        sortable: false,
        class: "body-1 font-weight-bold",
      },

      {
        text: "Created At (By)",
        value: "created_at",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 150,
        sortable: false,
      },
      {
        text: "Updated At (By)",
        value: "updated_at",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 150,
        sortable: false,
      },
    ],
    stores: [],
    infor_storer_id: null,
    clientLoader: false,
    uploadOrder: false,
    clientName: "",
    parent_outbound_id__receipt_key: "",
    infor_storer_id_text: "",
    errorFound: false,
    order_key: null,
  }),

  created() {
    this.fetchClientList();
    if (this.userCategory.user_category == 1) {
      this.client = this.$store.getters.user.id;
    }
    if (this.$route.query.id > 0) {
      this.getoutboundvariantDetails(this.$route.query.id)
        .then(async (res) => {
          this.client = res.data.result.client_id;
          this.clientName = res.data.result.client_id__name;
          this.receipt = res.data.result.parent_inbound_id;
          this.parent_outbound_id__receipt_key =
            res.data.result.parent_outbound_id__order_key;
          this.list = res.data.result2.items;
          this.infor_storer_id_text = res.data.result.channel_id__channel_name;
          this.infor_storer_id = res.data.result.channel_id;
          this.order_id = res.data.result.parent_outbound_id;
          this.order_no = res.data.result.order_no;
          this.order_key = res.data.result.order_key;
        })
        .catch((e) => {
          if (e.status_code == 400) {
            this.errorFound = true;
          }
        });
    }
  },
  watch: {
    options: {
      handler() {},
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      "snackBar",
      "fetchClient",
      "uploadoutboundReceipt",
      "getChannelDropdownBB",
      "getOutboundReceiptNumber",
      "downloadOutboundvariantTemplate",
      "getoutboundvariantDetails",
      "updateoutboundReceipt",
      "downloadOutboundvariantEditTemplate",
    ]),
    listPage() {
      this.$router.push({
        name: "outboundordervariantStatusList",
        params: {
          type: "outbound_variant_upload",
        },
      });
    },
    downloadTemplate() {
      this.downloader = true;
      let payload = {
        id: this.$route.query.id,
        client_id: this.client,
      };
      this.downloadOutboundvariantEditTemplate(payload)
        .then((res) => {
          this.fileDownload(res);
          this.downloader = false;
        })
        .catch(() => {
          this.downloader = false;
        });
    },

    saveForm() {
      if (this.$refs.form.validate()) {
        this.uploadOrder = true;
        let formData = new FormData();
        formData.append("client_id", this.client);
        formData.append("data_file", this.file);
        formData.append("order_id", this.order_id);
        formData.append("storer_id", this.infor_storer_id);
        formData.append("variant_id", this.$route.query.id);

        this.updateoutboundReceipt(formData)
          .then((res) => {
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.$router.push("outbound-Variant");
            this.uploadOrder = false;
          })
          .catch(() => {
            this.uploadOrder = false;
          });
      }
    },
    reset() {
      this.$router.push("outbound-Variant");
    },

    download() {
      this.downloader = true;
      this.allFilters();
      this.downloadSkuList({ ...this.filtersArr }).then((res) => {
        this.fileDownload(res);
        this.downloader = false;
      });
    },
    clearDateInput(from) {
      if (from == "to_date") {
        this.to_date = null;
      } else {
        this.from_date = null;
      }
    },

    fetchClientList() {
      if (this.clients.length) return;

      if (
        this.clients.length === 0 &&
        (this.userCategory.user_category === 3 ||
          this.userCategory.user_category === 6)
      ) {
        this.clientLoader = true;

        this.fetchClient({
          fields: "id,name",
          pagination: 0,
          service: "b2b_fulfillment",
          variant: "1",
          active_facility: 1,
        })
          .then((res) => {
            this.clientLoader = false;
            this.clients = res.data;
          })
          .catch(() => {
            this.clientLoader = false;
          });
      }
    },
    getStores(id) {
      this.getChannelDropdownBB(id).then((res) => {
        this.stores = res.data;
      });
    },
  },
};
</script>
<style>
.custom-row .col-sm-2 {
  flex: 1 0 16.6666666667% !important;
  max-width: 21.666667% !important;
}
</style>
